import React from "react";
import LocationOnIcon from "@material-ui/icons/LocationOn";

import { Link } from "react-router-dom";
import { Lock, Public } from "@material-ui/icons";
import { Tooltip } from "@material-ui/core";
export const College = ({ type, name, location, website, logo }) => {
  return (
    <div className="college-item">
      <div className="flex ai-c p-2">
        <span className="college-logo-container">
          <img src={logo} className="college-logo" alt="amrit science campus" />
        </span>
        <div className="ml-2">
          <span className="college-name fw-500">
            {/* <Link
              target="_blank"
              to={`/college-website/${website}`}
              className="link text-blue"
            >
              {name}
            </Link> */}
            <a href={`${website}`} className="link text-blue">
              {name}
            </a>
            <br />
          </span>
          <div className="mt-1">
            {type === "Government" ? (
              <Tooltip title="Government College">
                <Public className="college-type" />
              </Tooltip>
            ) : (
              <Tooltip title="Private College">
                <Lock className="college-type" />
              </Tooltip>
            )}
          </div>
        </div>
      </div>
      <div className="p-2 flex ai-c college-location-container">
        <LocationOnIcon />
        <span className="ml-1 text-capitalize">{location}</span>
      </div>
    </div>
  );
};
